import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IssueService } from '../services/issue.service';

@Pipe({
  name: 'issuePriority'
})
export class IssuePriorityPipe implements PipeTransform {

  constructor(private _issueService: IssueService){

  }

  transform(value: number): Observable<string> {
    if(typeof value !== 'number') return null;
    return this._issueService.getAllIssuePriorities(true).pipe(map(x => x.find(y => y.priorityid === value))).pipe(map(x => x? x.priorityname: null));
  }

}
